exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".date-header-range-picker--container {\n  margin-right: 24px;\n}\n\n.date-header-range-picker--container * {\n  box-sizing: border-box;\n}\n\n.date-header--container {\n  display: flex;\n  align-items: center;\n  margin-bottom: 16px;\n}", ""]);

